module.exports = "/images/vendor/jquery-ui-dist/ui-icons_444444_256x240.png?0494d08913adc4581aa6a7da6c488d65";